import React from 'react';
import { createRoot } from 'react-dom/client';

import DataProvider from '../components/DataProvider';
import EmployeeList from '../components/Employee/EmployeeList';

export default function team(selector, api_url) {
    if( document.querySelector(selector) == null) return;

    //component can have multiple roots and can be rendered multiple times on a single page
    let nodes = document.querySelectorAll(selector);

    nodes.forEach( node => {

        const root = createRoot(node);
        
        root.render(
            <DataProvider api_url={api_url} message_empty={wp_core.i18n.no_posts}>
                <EmployeeList />
            </DataProvider>
        );

    });
}